import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import ListItemSecondaryAction from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';
import ListItemAvatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemAvatar';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  hide: {
    display: 'none',
  },
  listItemAvatar: {},
  listItemAvatarSkeleton: {},
  listItemText: {},
  listItemTextPrimarySkeleton: {},
  listItemTextSecondarySkeleton: {},
  listItemSecondaryAction: {},
  listItemSecondaryActionSkeleton: {},
});

const ListItemSkeleton = ({
  className,
  classes,
  showAvatar,
  showSecondary,
  showSecondaryAction,
  AvatarProps,
  PrimaryProps,
  SecondaryProps,
  SecondaryActionProps,
}) => {
  return (
    <ListItem
      className={classNames(classes.root, className)}
    >
      <ListItemAvatar
        className={classNames(classes.listItemAvatar, {
          [classes.hide]: !showAvatar,
        })}
      >
        <Skeleton
          className={classes.listItemAvatarSkeleton}
          variant="circle"
          width={40}
          height={40}
          {...AvatarProps}
        />
      </ListItemAvatar>
      <ListItemText
        className={classes.listItemText}
        primary={
          <Skeleton
            className={classes.listItemTextPrimarySkeleton}
            width={150}
            {...PrimaryProps}
          />
        }
        secondary={
          <Skeleton
            className={classNames(classes.listItemTextSecondarySkeleton, {
              [classes.hide]: !showSecondary,
            })}
            width={200}
            {...SecondaryProps}
          />
        }
      />
      <ListItemSecondaryAction
        className={classNames(classes.listItemSecondaryAction, {
          [classes.hide]: !showSecondaryAction,
        })}
      >
        <Skeleton
          className={classes.listItemSecondaryActionSkeleton}
          variant="circle"
          width={20}
          height={20}
          {...SecondaryActionProps}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

ListItemSkeleton.defaultProps = {
  className: '',
  showAvatar: true,
  showSecondary: true,
  showSecondaryAction: true,
};

ListItemSkeleton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  showAvatar: PropTypes.bool,
  showSecondary: PropTypes.bool,
  showSecondaryAction: PropTypes.bool,
};

export default withStyles(styles)(ListItemSkeleton);
